import _ from 'underscore';
import { TargetingSettingsContext } from './targeting-settings-context';
import { TargetingLevel, TargetingType } from './config';

export function getFilterStateConfig({
  setting,
  level,
}) {
  return {
    mapOnlyBaseProperty: false,
    entity: (() => {
      let filterList = ['Campaign/Id', 'Campaign/Name', 'Campaign/CampaignType', 'AdGroup/Id', 'AdGroup/Name', 'CriterionBid', 'LevelOfDetails'];

      if (setting === TargetingType.Devices) {
        filterList = filterList.concat(['Criterion/DeviceCriterion/DeviceName']);
      } else if (setting === TargetingType.AdSchedule) {
        filterList = filterList.concat(['Criterion/DayTimeCriterion/Day']);
      } else if (setting === TargetingType.Locations) {
        filterList = filterList.concat(['Criterion/Webpage/Parameter/CriterionName']);
      } else if (setting === TargetingType.AllSettings) {
        filterList = filterList.concat(['Campaign/Status']);
      }

      filterList = filterList.concat(['Campaign/IsExperiment']);

      const criterion = level === TargetingLevel.AdGroup ?
        TargetingSettingsContext.BiddableAdGroupCriterion :
        TargetingSettingsContext.BiddableCampaignCriterion;

      const rootSchema = TargetingSettingsContext.updateFilterSchemaForPilotFeatures(criterion);
      if (rootSchema.properties.AdGroup) {
        // enable filter by ad group Id only for settings grid
        _.extend(rootSchema.properties.AdGroup.schema.properties.Id, { filterable: true });
      }
      let filterEntityOptions = TargetingSettingsContext.filterOptionsFromSchema(rootSchema, true);

      const biPattern = /^PerformanceMetrics\//;
      filterEntityOptions.fields = _.filter(
        filterEntityOptions.fields,
        field => _.contains(filterList, field.property) || biPattern.test(field.property)
      );

      filterEntityOptions = TargetingSettingsContext
        .appendPeriodOverPeriodFields(filterEntityOptions);

      const deviceNameOption = _.findWhere(
        filterEntityOptions.fields,
        { property: 'Criterion/DeviceCriterion/DeviceName' }
      );

      if (!_.isEmpty(deviceNameOption)) {
        deviceNameOption.enum = _.map(
          deviceNameOption.enum,
          value => value.replace('Enum.DeviceName\'', '').replace('\'', '')
        );
        deviceNameOption.localized = _.object(
          _.map(_.keys(deviceNameOption.localized), value => value.replace('Enum.DeviceName\'', '').replace('\'', '')),
          _.values(deviceNameOption.localized)
        );
      }

      const levelOfDetailsOption = _.findWhere(
        filterEntityOptions.fields,
        { property: 'LevelOfDetails' }
      );
      if (!_.isEmpty(levelOfDetailsOption)) {
        levelOfDetailsOption.enum = _.map(
          levelOfDetailsOption.enum,
          value => value.replace('Enum.LevelOfDetails\'', '').replace('\'', '')
        );
        levelOfDetailsOption.localized = _.object(
          _.map(_.keys(levelOfDetailsOption.localized), value => value.replace('Enum.LevelOfDetails\'', '').replace('\'', '')),
          _.values(levelOfDetailsOption.localized)
        );
      }

      const criterionNameIndex = _.findIndex(filterEntityOptions.fields, item =>
        item.name === 'CriterionName');
      if (criterionNameIndex !== -1) {
        if (setting === TargetingType.Locations) {
          const locationNameOption = filterEntityOptions.fields[criterionNameIndex];
          // TODO(quye): fix on schema side, now is 'Criterion/Webpage/Parameter/CriterionName'
          locationNameOption.property = 'Criterion/Name';
        }
      }

      const campaignIdOption = _.find(filterEntityOptions.fields, item => item.property === 'Campaign/Id');
      if (!_.isEmpty(campaignIdOption)) {
        campaignIdOption.title = TargetingSettingsContext.i18n.getString('FilterColumn_CampaignID');
        campaignIdOption.name = 'CampaignId';
      }

      const campaignNameOption = _.find(filterEntityOptions.fields, item => item.property === 'Campaign/Name');
      if (!_.isEmpty(campaignNameOption)) {
        campaignNameOption.title = TargetingSettingsContext.i18n.getString('FilterColumn_CampaignName');
        campaignNameOption.name = 'CampaignName';
      }

      const adGroupIdOption = _.find(filterEntityOptions.fields, item => item.property === 'AdGroup/Id');
      if (!_.isEmpty(adGroupIdOption)) {
        adGroupIdOption.title = TargetingSettingsContext.i18n.getString('FilterColumn_AdgroupID');
        adGroupIdOption.name = 'AdGroupId';
      }

      const adGroupNameOption = _.find(filterEntityOptions.fields, item => item.property === 'AdGroup/Name');
      if (!_.isEmpty(adGroupNameOption)) {
        adGroupNameOption.title = TargetingSettingsContext.i18n.getString('FilterColumn_AdGroupName');
        adGroupNameOption.name = 'AdGroupName';
      }

      return filterEntityOptions;
    })(),
    options: (() => {
      const options = { odata: { custom: {} } };

      _.extendOwn(options.odata.custom, {
        Criterion: {
          isof: value => `isof(Criterion, ${value})`,
        },
        'Criterion/DeviceCriterion/DeviceName': (operator, value) => {
          const obj = {};

          obj[`$${operator}`] = value;

          const filter = { 'Criterion/Model.DeviceCriterion/DeviceName': obj };
          const filterStr = TargetingSettingsContext.ODataConverter.convert(filter);

          return filterStr.replace('Model/DeviceCriterion', 'Model.DeviceCriterion');
        },
        'Criterion/DayTimeCriterion/Day': (operator, value) => {
          const obj = {};

          obj[`$${operator}`] = value;

          const filter = { 'Criterion/Model.DayTimeCriterion/Day': obj };
          const filterStr = TargetingSettingsContext.ODataConverter.convert(filter);

          return filterStr.replace('Model/DayTimeCriterion', 'Model.DayTimeCriterion');
        },
        'Campaign/IsExperiment': {
          eq: (val) => {
            const operator = val ? 'gt' : 'le';

            return `Campaign/ExperimentId ${operator} 0`;
          },
        },
      });

      return options;
    })(),
  };
}
